// Fonctionnalités activables au build.
// « Value » (Value Finder, Value du jour, alertes, badges VALUE) : RETIRÉE. Le backtest sur 12 459 matchs montre
// que parier sur les écarts modèle / cotes fait perdre ≈ 13 % : HitMax ne présente plus ces écarts comme des
// opportunités. Réactivable uniquement avec REACT_APP_VALUE_ENABLED=true (tests automatisés).
export const isValueEnabled = () => process.env.REACT_APP_VALUE_ENABLED === "true";
